import { useTranslation as useTranslationLib } from 'react-i18next'

import { TRANSLATION_NAMESPACE } from './setupTranslations'

export const useTranslation = () => useTranslationLib(TRANSLATION_NAMESPACE)
